/* eslint-disable no-param-reassign */
/* eslint-disable import/prefer-default-export */
import { toastr } from "react-redux-toastr";
import { fetchData, fetchRequest } from "../../utils/http";
import { getAccessToken } from "../../utils/tokens";
import {
  getClientServiceUrl as clientServiceUrl,
  getHttpProtocol as scheme,
} from "../../utils/requests";

export const editRegistration = async (params) => {
  const path = `${window.location.origin}/calendar/edit_registration/${params.reservationUuid}`;

  const body = [];
  body.remove_late_cancel = params.removeLateCancel;
  body.remove_no_show = params.removeNoShow;
  body.forgiven = params.forgiven;
  body.charged = params.charged;
  body.client_id = params.userUuid;
  body.status = params.status;
  body.pk = params.pk;

  try {
    const resp = await fetchRequest({
      method: "POST",
      path,
      body,
    });

    const respBody = await resp.json();
    const message = `${params.class} ${params.date} for ${params.fullName} was ${params.status}`;
    if (respBody.success === 1) {
      toastr.success("Success", message);
    } else {
      toastr.error("Error", "An error occured. Please try again later.");
    }
    return respBody.success;
  } catch (err) {
    toastr.error("Error", "An error occured. Please try again later.");
    return 0;
  }
};

export const getClasses = async (clientId) => {
  const path = `${scheme}//${clientServiceUrl}/client/${clientId}/report/no-show/get-class-type`;

  const token = getAccessToken();

  const request = {
    path,
    options: {
      token,
      headers: { "Content-Type": "application/json" },
    },
  };
  const { data } = await fetchData(request, true);

  return data.data;
};

export const getPersons = async (clientId) => {
  const path = `${scheme}//${clientServiceUrl}/client/${clientId}/report/no-show/get-persons`;

  const token = getAccessToken();

  const request = {
    path,
    options: {
      token,
      headers: { "Content-Type": "application/json" },
    },
  };
  const { data } = await fetchData(request, true);

  return data.data;
};

export const getBuckets = async (clientId, period = false) => {
  const path = `${scheme}//${clientServiceUrl}/client/${clientId}/report/no-show/get-buckets${
    period ? `?period=${period}` : ""
  }`;

  const token = getAccessToken();

  const request = {
    path,
    options: {
      token,
      headers: { "Content-Type": "application/json" },
    },
  };
  const { data } = await fetchData(request, true);

  return data.data;
};

export const getSummary = async (clientId, status, user, period = false) => {
  const path = `${scheme}//${clientServiceUrl}/client/${clientId}/report/no-show/get-summary?status=${status}&user=${user}${
    period ? `&period=${period}` : ""
  }`;

  const token = getAccessToken();

  const request = {
    path,
    options: {
      token,
      headers: { "Content-Type": "application/json" },
    },
  };
  const { data } = await fetchData(request, true);

  return data;
};

export const getData = async (option) => {
  const {
    clientId,
    from,
    size,
    filters: { classType, person, status, dateStart, dateEnd },
  } = option;

  const start = new Date(dateStart);
  start.setUTCHours(0, 0, 0, 0);

  const end = new Date(dateEnd);
  end.setUTCHours(23, 59, 59, 999);

  const personQuery = person ? `&person=${person}` : "";
  const classQuery = classType.reduce((acc, cur) => {
    acc = acc.concat(`&classes[]=${cur}`);
    return acc;
  }, "");

  const statusQuery = status.reduce((acc, cur) => {
    acc = acc.concat(`&status[]=${cur}`);
    return acc;
  }, "");

  const path = `${scheme}//${clientServiceUrl}/client/${clientId}/report/no-show/get-data?from=${from}&size=${size}&start=${
    start.getTime() / 1000
  }&end=${end.getTime() / 1000}${personQuery}${classQuery}${statusQuery}`;

  const token = getAccessToken();
  const request = {
    path,
    options: {
      token,
      headers: { "Content-Type": "application/json" },
    },
  };
  const { data } = await fetchData(request, true);
  data.data.forEach((row) => {
    row.memberUrl = `${window.location.origin}/members/view/${row.userUuid}`;
    row.createCharge = `${window.location.origin}/invoices/create/${row.userUuid}`;
    row.classUrl = `${window.location.origin}/schedule/${row.calendarItemUuid}`;

    // adusting timezone to user gyms view prespective
    const offset = new Date().getTimezoneOffset();
    const classDate = new Date(row.classDate);
    classDate.setMinutes(classDate.getMinutes() + offset);
    row.classDate = classDate;
  });

  return data;
};
